module.exports = __webpack_public_path__ + "resources/img/solution_finance_infra2.5a7ae0786bfb466db6e66ab2a826700a.png";